<script lang="ts">
	import { Image } from "@unpic/svelte";
	import { getContext } from "svelte";
	import type { BrandKit } from "#gen/brands/v1/service_pb.js";
	import type { LandingPage } from "#gen/bundles/v1/bundle_pb.js";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import Avatar from "#lib/components/Avatar.svelte";
	import Icon from "#lib/components/Icon.svelte";
	import { transformURL } from "#lib/image.js";
	import { getBrowserChromeColor, getPrimaryLogo, getTextColor } from "#lib/theme.js";
	import type { Readable, Writable } from "svelte/store";

	interface Props {
		landingPage: Readable<LandingPage>;
		readOnly?: boolean;
		onShare?: () => void;
		onMenu?: () => void;
	}

	const user: Writable<User> = getContext("user");
	const brandKit: Writable<BrandKit | undefined> = getContext("brandKit");

	const { landingPage, readOnly = false, onShare, onMenu }: Props = $props();
	const logo = $derived(getPrimaryLogo($brandKit));
</script>

<div class="flex flex-none items-center justify-between px-4">
	<div class="max-w-[25%]">
		{#if logo && logo.url}
			<Image src={transformURL(logo.url)} layout="fullWidth" loading="eager" priority={true} alt="Logo" height={32} style="width: inherit; object-fit: contain;" />
		{/if}
	</div>
	<div class="flex flex-none gap-4" style="color: {getTextColor(getBrowserChromeColor($brandKit, $landingPage))};">
		<button type="button" disabled={readOnly} onclick={onShare} class="rounded-xl p-0 opacity-90">
			<Icon name="share" />
			<span class="sr-only">Share</span>
		</button>
		{#if $user}
			<button type="button" disabled={readOnly} onclick={onMenu} aria-label="User menu" class="rounded-xl p-0">
				<Avatar class="object-contain" src={$user?.photoUrl} size="sm" referrerpolicy="no-referrer" />
			</button>
		{/if}
	</div>
</div>
